import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface Options {
  isInternal: boolean;
  url: string;
  replace?: boolean;
}

/**
 * Custom hook that returns a callback function for URL redirection.
 *
 * The returned callback function will navigate to the specified URL based on whether
 * it is an internal or external URL.
 *
 * @return {function} A callback function that takes an options object with `isInternal`
 * and `url` properties. The function redirects to the specified URL.
 */
const useRedirect = () => {
  const navigate = useNavigate();

  return useCallback(
    ({ isInternal, url, replace }: Options): void => {
      if (isInternal && url.startsWith('/life-insurance')) {
        navigate(url, { replace });
      } else if (isInternal) {
        navigate(`/life-insurance${url}`, { replace });
      } else {
        window.location.assign(url);
      }
    },
    [navigate]
  );
};

export default useRedirect;
